import React, { useContext, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { UserContext } from "./UserContext";
import Testata from "./partials/Testata";
import Footer from "./partials/Footer";

// Funzione helper per formattare le date in YYYY-MM-DD
const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    // Verifica se la data è valida
    if (isNaN(date.getTime())) {
      // Prova a interpretare come YYYY-MM-DD se fallisce la conversione standard
      // Questo può accadere se la stringa è già nel formato corretto ma viene passata a new Date()
      const parts = dateString.split('-');
      if (parts.length === 3 && !isNaN(parseInt(parts[0])) && !isNaN(parseInt(parts[1])) && !isNaN(parseInt(parts[2]))) {
        // Sembra già un formato YYYY-MM-DD valido o simile
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);
        if (year > 0 && month >= 1 && month <= 12 && day >=1 && day <=31) {
            return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
      }
      return ""; // Ritorna stringa vuota se la data non è valida
    }
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch (e) {
    console.error("Errore formattazione data:", e);
    return "";
  }
};

function Annuncio() {
  const { userData } = useContext(UserContext);
  const { id: annuncioId } = useParams();
  // const [annuncio, setAnnuncio] = useState(null); // formData ora contiene tutti i dati dell'annuncio per il form
  const [allegati, setAllegati] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showConfirmationModalAllegato, setShowConfirmationModalAllegato] = useState(false);
  const [annunciToDelete, setAnnunciToDelete] = useState(null);
  const [allegatoToDelete, setAllegatoToDelete] = useState(null);
  const navigate = useNavigate();
  const maxChars = 1000; // Per il campo "testo"
  const [isLoading, setIsLoading] = useState(true); // Per la UI di caricamento
  const [provinceFiltrate, setProvinceFiltrate] = useState([]); // Per le province filtrate
  
  const initialFormData = {
    id_utente: userData?.id || "",
    nome: "",
    cognome: "",
    codfisc: "",
    age: "",
    nato: "",
    natoA: "",
    decesso: "",
    mortoA: "",
    coniuge: "",
    comune: "",
    regione: "",
    prov: "",
    cap: "",
    funerale: "",
    cimitero: "",
    testo: "",
    img: "",
    cosa: "Necrologio"
  };

  const [formData, setFormData] = useState(initialFormData);

  const fetchAnnuncio = async () => {
    setIsLoading(true); // Inizia il caricamento
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/api/annuncio/${annuncioId}`, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        credentials: "include",
      });
      if (response.ok) {
        const data = await response.json();
        const processedData = {
          ...initialFormData,
          ...data,
          id_utente: data.id_utente || userData?.id || "",
          nato: formatDateForInput(data.nato), // Già corretto
          decesso: formatDateForInput(data.decesso), // Già corretto
          nome: (data.nome || "").toUpperCase(), // MODIFICATO
          cognome: (data.cognome || "").toUpperCase(), // MODIFICATO
          codfisc: (data.codfisc || "").toUpperCase(), // MODIFICATO (se vuoi che sia sempre maiuscolo)
          age: data.age || "", // Lascia com'è (numero)
          natoA: (data.natoA || "").toUpperCase(), // MODIFICATO
          mortoA: (data.mortoA || "").toUpperCase(), // MODIFICATO
          coniuge: (data.coniuge || "").toUpperCase(), // MODIFICATO
          comune: (data.comune || "").toUpperCase(), // MODIFICATO
          regione: (data.regione || "").toUpperCase(), // FONDAMENTALE - MODIFICATO
          prov: (data.prov || "").toUpperCase(),       // FONDAMENTALE - MODIFICATO
          cap: (data.cap || "").toUpperCase(), // MODIFICATO
          funerale: (data.funerale || "").toUpperCase(), // MODIFICATO
          cimitero: (data.cimitero || "").toUpperCase(), // MODIFICATO
          testo: data.testo || "", // Lascia com'è o gestisci in handleChange
          img: data.img || "",
          cosa: data.cosa || "Necrologio",
        };
        setFormData(processedData);
      } else {
        throw new Error("Errore nel recupero dell'anagrafica");
      }
    } catch (err) {
      setError(err.message);
    } 
    finally { // AGGIUNGI QUESTO BLOCCO
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAnnuncio();
  }, [annuncioId, userData?.id]); // Aggiunto userData.id per id_utente

  const fetchAllegati = async () => { 
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `/api/allegati/${annuncioId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );

      if (response.ok) {
        const data = await response.json();
        setAllegati(data);
      } else {
        throw new Error("Errore nel recupero degli Allegati");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  useEffect(() => { fetchAllegati(); }, [annuncioId]);

  const province = [
  // ABRUZZO
  { sigla: 'CH', nome: 'Chieti', regioneNomeEsteso: 'ABRUZZO' },
  { sigla: 'AQ', nome: 'L\'Aquila', regioneNomeEsteso: 'ABRUZZO' },
  { sigla: 'PE', nome: 'Pescara', regioneNomeEsteso: 'ABRUZZO' },
  { sigla: 'TE', nome: 'Teramo', regioneNomeEsteso: 'ABRUZZO' },
  // BASILICATA
  { sigla: 'MT', nome: 'Matera', regioneNomeEsteso: 'BASILICATA' },
  { sigla: 'PZ', nome: 'Potenza', regioneNomeEsteso: 'BASILICATA' },
  // CALABRIA
  { sigla: 'CZ', nome: 'Catanzaro', regioneNomeEsteso: 'CALABRIA' },
  { sigla: 'CS', nome: 'Cosenza', regioneNomeEsteso: 'CALABRIA' },
  { sigla: 'KR', nome: 'Crotone', regioneNomeEsteso: 'CALABRIA' },
  { sigla: 'RC', nome: 'Reggio Calabria', regioneNomeEsteso: 'CALABRIA' },
  { sigla: 'VV', nome: 'Vibo Valentia', regioneNomeEsteso: 'CALABRIA' },
  // CAMPANIA
  { sigla: 'AV', nome: 'Avellino', regioneNomeEsteso: 'CAMPANIA' },
  { sigla: 'BN', nome: 'Benevento', regioneNomeEsteso: 'CAMPANIA' },
  { sigla: 'CE', nome: 'Caserta', regioneNomeEsteso: 'CAMPANIA' },
  { sigla: 'NA', nome: 'Napoli', regioneNomeEsteso: 'CAMPANIA' },
  { sigla: 'SA', nome: 'Salerno', regioneNomeEsteso: 'CAMPANIA' },
  // EMILIA ROMAGNA (o EMILIA-ROMAGNA, basato sulla tua formattazione precedente)
  { sigla: 'BO', nome: 'Bologna', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'FE', nome: 'Ferrara', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'FC', nome: 'Forlì-Cesena', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'MO', nome: 'Modena', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'PR', nome: 'Parma', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'PC', nome: 'Piacenza', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'RA', nome: 'Ravenna', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'RE', nome: 'Reggio Emilia', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  { sigla: 'RN', nome: 'Rimini', regioneNomeEsteso: 'EMILIA ROMAGNA' },
  // FRIULI VENEZIA GIULIA (attenzione alla virgola se presente nel tuo array regioni)
  { sigla: 'GO', nome: 'Gorizia', regioneNomeEsteso: 'FRIULI VENEZIA GIULIA,' },
  { sigla: 'PN', nome: 'Pordenone', regioneNomeEsteso: 'FRIULI VENEZIA GIULIA,' },
  { sigla: 'TS', nome: 'Trieste', regioneNomeEsteso: 'FRIULI VENEZIA GIULIA,' },
  { sigla: 'UD', nome: 'Udine', regioneNomeEsteso: 'FRIULI VENEZIA GIULIA,' },
  // LAZIO
  { sigla: 'FR', nome: 'Frosinone', regioneNomeEsteso: 'LAZIO' },
  { sigla: 'LT', nome: 'Latina', regioneNomeEsteso: 'LAZIO' },
  { sigla: 'RI', nome: 'Rieti', regioneNomeEsteso: 'LAZIO' },
  { sigla: 'RM', nome: 'Roma', regioneNomeEsteso: 'LAZIO' },
  { sigla: 'VT', nome: 'Viterbo', regioneNomeEsteso: 'LAZIO' },
  // LIGURIA
  { sigla: 'GE', nome: 'Genova', regioneNomeEsteso: 'LIGURIA' },
  { sigla: 'IM', nome: 'Imperia', regioneNomeEsteso: 'LIGURIA' },
  { sigla: 'SP', nome: 'La Spezia', regioneNomeEsteso: 'LIGURIA' },
  { sigla: 'SV', nome: 'Savona', regioneNomeEsteso: 'LIGURIA' },
  // LOMBARDIA
  { sigla: 'BG', nome: 'Bergamo', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'BS', nome: 'Brescia', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'CO', nome: 'Como', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'CR', nome: 'Cremona', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'LC', nome: 'Lecco', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'LO', nome: 'Lodi', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'MN', nome: 'Mantova', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'MI', nome: 'Milano', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'MB', nome: 'Monza e della Brianza', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'PV', nome: 'Pavia', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'SO', nome: 'Sondrio', regioneNomeEsteso: 'LOMBARDIA' },
  { sigla: 'VA', nome: 'Varese', regioneNomeEsteso: 'LOMBARDIA' },
  // MARCHE
  { sigla: 'AN', nome: 'Ancona', regioneNomeEsteso: 'MARCHE' },
  { sigla: 'AP', nome: 'Ascoli Piceno', regioneNomeEsteso: 'MARCHE' },
  { sigla: 'FM', nome: 'Fermo', regioneNomeEsteso: 'MARCHE' },
  { sigla: 'MC', nome: 'Macerata', regioneNomeEsteso: 'MARCHE' },
  { sigla: 'PU', nome: 'Pesaro e Urbino', regioneNomeEsteso: 'MARCHE' },
  // MOLISE (attenzione allo spazio se presente nel tuo array regioni)
  { sigla: 'CB', nome: 'Campobasso', regioneNomeEsteso: 'MOLISE ' },
  { sigla: 'IS', nome: 'Isernia', regioneNomeEsteso: 'MOLISE ' },
  // PIEMONTE
  { sigla: 'AL', nome: 'Alessandria', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'AT', nome: 'Asti', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'BI', nome: 'Biella', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'CN', nome: 'Cuneo', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'NO', nome: 'Novara', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'TO', nome: 'Torino', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'VB', nome: 'Verbano-Cusio-Ossola', regioneNomeEsteso: 'PIEMONTE' },
  { sigla: 'VC', nome: 'Vercelli', regioneNomeEsteso: 'PIEMONTE' },
  // PUGLIA
  { sigla: 'BA', nome: 'Bari', regioneNomeEsteso: 'PUGLIA' },
  { sigla: 'BT', nome: 'Barletta-Andria-Trani', regioneNomeEsteso: 'PUGLIA' },
  { sigla: 'BR', nome: 'Brindisi', regioneNomeEsteso: 'PUGLIA' },
  { sigla: 'FG', nome: 'Foggia', regioneNomeEsteso: 'PUGLIA' },
  { sigla: 'LE', nome: 'Lecce', regioneNomeEsteso: 'PUGLIA' },
  { sigla: 'TA', nome: 'Taranto', regioneNomeEsteso: 'PUGLIA' },
  // SARDEGNA
  { sigla: 'CA', nome: 'Cagliari', regioneNomeEsteso: 'SARDEGNA' },
  { sigla: 'NU', nome: 'Nuoro', regioneNomeEsteso: 'SARDEGNA' },
  { sigla: 'OR', nome: 'Oristano', regioneNomeEsteso: 'SARDEGNA' },
  { sigla: 'SS', nome: 'Sassari', regioneNomeEsteso: 'SARDEGNA' },
  { sigla: 'SU', nome: 'Sud Sardegna', regioneNomeEsteso: 'SARDEGNA' }, // Provincia del Sud Sardegna
  // SICILIA
  { sigla: 'AG', nome: 'Agrigento', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'CL', nome: 'Caltanissetta', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'CT', nome: 'Catania', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'EN', nome: 'Enna', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'ME', nome: 'Messina', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'PA', nome: 'Palermo', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'RG', nome: 'Ragusa', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'SR', nome: 'Siracusa', regioneNomeEsteso: 'SICILIA' },
  { sigla: 'TP', nome: 'Trapani', regioneNomeEsteso: 'SICILIA' },
  // TOSCANA
  { sigla: 'AR', nome: 'Arezzo', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'FI', nome: 'Firenze', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'GR', nome: 'Grosseto', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'LI', nome: 'Livorno', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'LU', nome: 'Lucca', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'MS', nome: 'Massa-Carrara', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'PI', nome: 'Pisa', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'PT', nome: 'Pistoia', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'PO', nome: 'Prato', regioneNomeEsteso: 'TOSCANA' },
  { sigla: 'SI', nome: 'Siena', regioneNomeEsteso: 'TOSCANA' },
  // TRENTINO-ALTO ADIGE
  { sigla: 'BZ', nome: 'Bolzano/Bozen', regioneNomeEsteso: 'TRENTINO ALTO ADIGE' },
  { sigla: 'TN', nome: 'Trento', regioneNomeEsteso: 'TRENTINO ALTO ADIGE' },
  // UMBRIA
  { sigla: 'PG', nome: 'Perugia', regioneNomeEsteso: 'UMBRIA' },
  { sigla: 'TR', nome: 'Terni', regioneNomeEsteso: 'UMBRIA' },
  // VALLE D'AOSTA (o VAL D'AOSTA, attenzione all'apostrofo)
  { sigla: 'AO', nome: 'Aosta', regioneNomeEsteso: 'VALLE D\'AOSTA' },
  // VENETO
  { sigla: 'BL', nome: 'Belluno', regioneNomeEsteso: 'VENETO' },
  { sigla: 'PD', nome: 'Padova', regioneNomeEsteso: 'VENETO' },
  { sigla: 'RO', nome: 'Rovigo', regioneNomeEsteso: 'VENETO' },
  { sigla: 'TV', nome: 'Treviso', regioneNomeEsteso: 'VENETO' },
  { sigla: 'VE', nome: 'Venezia', regioneNomeEsteso: 'VENETO' },
  { sigla: 'VR', nome: 'Verona', regioneNomeEsteso: 'VENETO' },
  { sigla: 'VI', nome: 'Vicenza', regioneNomeEsteso: 'VENETO' },
  ];
  const regioni = [
    { sigla: 'ABRUZZO', nome: 'ABRUZZO' },
    { sigla: 'BASILICATA', nome: 'BASILICATA' },
    { sigla: 'CALABRIA', nome: 'CALABRIA' },
    { sigla: 'CAMPANIA', nome: 'CAMPANIA' },
    { sigla: 'EMILIA ROMAGNA', nome: 'EMILIA ROMAGNA' },
    { sigla: 'FRIULI VENEZIA GIULIA,', nome: 'FRIULI VENEZIA GIULIA,' },
    { sigla: 'LAZIO', nome: 'LAZIO' },
    { sigla: 'LIGURIA', nome: 'LIGURIA' },
    { sigla: 'LOMBARDIA', nome: 'LOMBARDIA' },
    { sigla: 'MARCHE', nome: 'MARCHE' },
    { sigla: 'MOLISE', nome: 'MOLISE' },
    { sigla: 'PIEMONTE', nome: 'PIEMONTE' },
    { sigla: 'PUGLIA', nome: 'PUGLIA' },
    { sigla: 'SARDEGNA', nome: 'SARDEGNA' },
    { sigla: 'SICILIA', nome: 'SICILIA' },
    { sigla: 'TOSCANA', nome: 'TOSCANA' },
    { sigla: 'TRENTINO ALTO ADIGE', nome: 'TRENTINO ALTO ADIGE' },
    { sigla: 'UMBRIA', nome: 'UMBRIA' },
    { sigla: 'VENETO', nome: 'VENETO' },
    { sigla: 'VALLE D\'AOSTA', nome: 'VALLE D\'AOSTA' },
  ];
  useEffect(() => {
    if (formData.regione) {
      // formData.regione dovrebbe essere già MAIUSCOLO
      const provinceDellaRegione = province.filter( // 'province' è il tuo array completo
        (provItem) => provItem.regioneNomeEsteso === formData.regione
      );
      setProvinceFiltrate(provinceDellaRegione);
    } else {
      setProvinceFiltrate([]); // Se nessuna regione è selezionata, svuota
    }
  }, [formData.regione]); // Dipende solo da formData.regione

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    if (file) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        img: file.name, // Aggiorna formData con il nome del file per l'immagine principale
      }));
    } else {
      // Se il file viene deselezionato, potresti voler mantenere il nome dell'immagine precedente
      // o pulirlo, a seconda della logica desiderata.
      setFormData((prevFormData) => ({ ...prevFormData, img: "" }));
    }
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let processedValue;

    if (type === "date" || type === "number") {
      processedValue = value;
    } else if (typeof value === 'string') {
      processedValue = value.toUpperCase();
    } else {
      processedValue = value;
    }

    if (name === "regione") { // AGGIUNTA QUESTA CONDIZIONE
      setFormData((prevFormData) => ({
        ...prevFormData,
        regione: processedValue, // processedValue è già MAIUSCOLO
        prov: "", // Resetta la provincia quando la regione cambia
      }));
    } else if (name === "testo") {
      if (value.length <= maxChars) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: processedValue,
        }));
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: processedValue,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const dataToSend = new FormData(); // Usiamo FormData per inviare file e altri dati

      // Creiamo una copia dei dati con valori puliti
      const cleanedData = { ...formData };
      
      // Convertiamo le stringhe vuote in null per i campi data, se necessario
      if (!cleanedData.nato) {
        cleanedData.nato = null;
      }
      if (!cleanedData.decesso) {
        cleanedData.decesso = null;
      }
      
      // Appendi tutti i campi da formData. Applica toUpperCase qui se non fatto in handleChange
      // per assicurarsi che i dati inviati siano consistenti.
      // La handleChange già gestisce toUpperCase per i campi stringa.
      for (const key in cleanedData) {
        if (cleanedData.hasOwnProperty(key)) { // Buona pratica
          dataToSend.append(key, cleanedData[key]);
        }
      }

      if (selectedFile) { // Se un nuovo file è stato selezionato per l'immagine principale
        dataToSend.append('file', selectedFile, formData.img); // Il terzo argomento è il nome del file
      } else if (formData.img) {
        // Se non è stato selezionato un nuovo file, ma c'era un'immagine esistente,
        // non abbiamo bisogno di inviarla di nuovo a meno che non si voglia solo aggiornare il nome.
        // Per PATCH, inviamo solo ciò che cambia. Se formData.img non è cambiato e selectedFile è null,
        // il backend non dovrebbe toccare l'immagine. Se il nome in formData.img è stato cancellato,
        // si potrebbe voler inviare un segnale per rimuovere l'immagine.
        // Assumiamo che se selectedFile è null, non si vuole cambiare l'immagine esistente.
        // dataToSend.append('img', formData.img); // Invia il nome dell'immagine esistente se necessario
      }

      const response = await fetch(`/api/annuncio/${annuncioId}`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}` /* FormData imposta Content-Type automaticamente */ },
        credentials: 'include',
        body: dataToSend,
      });

      if (response.ok) {
      const responseData = await response.json();
      setShowSuccessMessage(true);
      setTimeout(() => setShowSuccessMessage(false), 3000);

      // Aggiorna lo stato del form con i dati restituiti dal server
      // assicurandoti che le date siano nel formato corretto YYYY-MM-DD
      const updatedProcessedData = {
        ...responseData,
        nato: formatDateForInput(responseData.nato),
        decesso: formatDateForInput(responseData.decesso),
      };
      setFormData(updatedProcessedData);
      setSelectedFile(null);
      setEditMode(false);
    } else {
      const errorData = await response.json();
      alert(errorData.error || 'Errore durante il salvataggio delle modifiche');
    }
    } catch (err) {
      console.error('Errore durante il salvataggio:', err);
      alert('Si è verificato un errore durante il salvataggio. Verifica i dati e la connessione.');
    }
  };
  const handleDeleteAnnuncio = (annuncioId) => {
    setAnnunciToDelete(annuncioId);
    setShowConfirmationModal(true);
  };
  const confirmDeleteAnnuncio = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/annuncio/${annunciToDelete}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        credentials: 'include',
      });

      if (response.ok) {
        // Reindirizza l'utente alla dashboard
        navigate('/dashboard'); 
      } else {
        // Gestisci l'errore di eliminazione
        const errorData = await response.json(); 
        setError(errorData.error || 'Errore durante l\'eliminazione dell\'annuncio');
      }
    } catch (err) {
      console.error('Errore:', err);
    setError('Errore durante l\'eliminazione dell\'annuncio'); // Gestisci l'errore di rete
  } finally {
    setShowConfirmationModal(false);
    setAnnunciToDelete(null);
  }
  };
  const handleDeleteAllegato = (allegatoId) => {
    setAllegatoToDelete(allegatoId);
    setShowConfirmationModalAllegato(true);
  };
  const confirmDeleteAllegato = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/allegato/${allegatoToDelete}`, { 
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        credentials: 'include',
      });

      if (response.ok) {
        // Aggiorna la lista degli allegati dopo l'eliminazione
        setAllegati(allegati.filter(allegato => allegato._id !== allegatoToDelete));
      } else {
        throw new Error('Errore durante l\'eliminazione dell\'allegato');
      }
    } catch (err) {
      console.error('Errore:', err);
      // Gestisci l'errore (ad esempio, mostra un messaggio all'utente)
    } finally {
      setShowConfirmationModalAllegato(false);
      setAllegatoToDelete(null);
    }
  };

  // Se annuncio non è ancora caricato (formData non è popolato dai dati fetchati)
  if (isLoading) { // Usa il nuovo stato isLoading
    return <p>Caricamento annuncio...</p>;
  }

  return (
    <>
      <section className="main_content dashboard_part">
        <div className='container-fluid g-0'>
          <Testata userData={userData} />
        </div>
        <div className="main_content_iner dashboard_part">
          <div className="container-fluid plr_30 body_white_bg pt_30">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="white_box_tittle list_header">
                  <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
                    <h4><a href="/dashboard"><i className="ti-arrow-circle-left" style={{fontSize: '0.8rem'}}></i> Indietro</a> &nbsp; | &nbsp; Dettaglio Annuncio</h4>
                    <div className="d-flex" style={{ justifyContent: 'flex-end', gap: '10px' }}>
                      <button 
                        className="btn btn-sm btn-danger" 
                        onClick={() => handleDeleteAnnuncio(annuncioId)} 
                        title="Elimina questo annuncio" 
                        style={{ marginRight: '10px' }}
                      >
                        <i className="ti-trash"></i> Elimina questo annuncio
                      </button>
                      <button 
                        className="btn btn-sm btn-outline-success" 
                        onClick={() => setEditMode(true)} 
                        title="Modifica questo annuncio"
                        disabled={editMode} // Disabilita il pulsante quando non sei in modalità modifica
                      >
                        Modifica
                      </button>
                    </div>
                  </div>
                </div>
                {error && <p className="error-message">{error}</p>}
                {/* Rimuovi {annuncio ? (...)} e usa direttamente formData
                    Assicurati che formData sia inizializzato correttamente o mostra un caricamento */}
                <form onSubmit={handleSubmit}>
                  <div className="col-12 mb_30">
                    <div className="row">
                        <div className="form-group col-md-2 col-sm-12 mb_20">
                            <label htmlFor="codfiscVisualizzato">Codice Fiscale:</label><br />
                            <b>{formData.codfisc}</b>
                            {/* Se codfisc deve essere modificabile, aggiungi un input e gestiscilo in formData */}
                        </div>
                        <div className="form-group col-md-2 cols-sm-6 mb_30">
                            <label htmlFor="age">Di anni:</label>
                            <input type="number" className="form-control" id="age" name="age" value={formData.age || ""} onChange={handleChange} disabled={!editMode} />
                        </div>
                        <div className="form-group col-md-4 col-sm-12 mb_20">
                            <label htmlFor="nome">Nome <b className="text text-danger">*</b>:</label>
                            <input type="text" className="form-control" id="nome" name="nome" value={formData.nome || ""} onChange={handleChange} disabled={!editMode} required aria-required="true" />
                        </div>
                        <div className="form-group col-md-4 col-sm-12 mb_20">
                            <label htmlFor="cognome">Cognome <b className="text text-danger">*</b>:</label>
                            <input type="text" className="form-control" id="cognome" name="cognome" value={formData.cognome || ""} onChange={handleChange} disabled={!editMode} required aria-required="true"/>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="nato">Nato il:</label>
                            <input type="date" className="form-control" id="nato" name="nato" value={formData.nato || ""} onChange={handleChange} disabled={!editMode} />
                        </div>
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="natoA">Nato a:</label>
                            <input type="text" className="form-control" id="natoA" name="natoA" value={formData.natoA || ""} onChange={handleChange} disabled={!editMode} />
                        </div>
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="decesso">Deceduto il <b className="text text-danger">*</b>:</label>
                            <input type="date" className="form-control" id="decesso" name="decesso" value={formData.decesso || ""} onChange={handleChange} disabled={!editMode} required aria-required="true" />
                        </div>
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="mortoA">Deceduto a <b className="text text-danger">*</b>:</label>
                            <input type="text" className="form-control" id="mortoA" name="mortoA" value={formData.mortoA || ""} onChange={handleChange} disabled={!editMode} required aria-required="true" />
                        </div>
                        <div className="form-group col-md-4 col-sm-12 mb_20">
                            <label htmlFor="coniuge">Nominativo del Coniuge:</label>
                            <input type="text" className="form-control" id="coniuge" name="coniuge" value={formData.coniuge || ""} onChange={handleChange} disabled={!editMode} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-4 col-sm-12 mb_20">
                            <label htmlFor="regione">Regione <b className="text text-danger">*</b>:</label>
                            <select className="form-select form-control" id="regione" name="regione" value={formData.regione || ""} onChange={handleChange} disabled={!editMode} required aria-required="true">
                                <option value="">Seleziona Regione</option>
                                {regioni.map(reg => (
                                  <option key={reg.sigla} value={reg.sigla}>{reg.nome}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="prov">Prov <b className="text text-danger">*</b>:</label>
                            <select className="form-select form-control" id="prov" name="prov" value={formData.prov || ""} onChange={handleChange} disabled={!editMode || !formData.regione} required={!!formData.regione} aria-required="true">
                              <option value="">Seleziona Provincia</option>
                              {provinceFiltrate.map(p => (
                                <option key={p.sigla} value={p.sigla.toUpperCase()}>{p.nome}</option>
                              ))}
                            </select>
                        </div>
                        <div className="form-group col-md-4 col-sm-12 mb_20">
                            <label htmlFor="comune">Comune <b className="text text-danger">*</b>:</label>
                            <input type="text" className="form-control" id="comune" name="comune" value={formData.comune || ""} onChange={handleChange} disabled={!editMode} required aria-required="true" />
                        </div>
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="cap">CAP <b className="text text-danger">*</b>:</label>
                            <input type="text" className="form-control" id="cap" name="cap" value={formData.cap || ""} onChange={handleChange} disabled={!editMode} required aria-required="true" />
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="form-group col-md-6 col-sm-12 mb_20">
                            <label htmlFor="funerale">Data e luogo del funerale <b className="text text-danger">*</b>:</label>
                            <textarea className="form-control" id="funerale" name="funerale" value={formData.funerale || ""} onChange={handleChange} disabled={!editMode} required aria-required="true" />
                        </div>
                        <div className="form-group col-md-6 col-sm-12 mb_20">
                            <label htmlFor="cimitero">Ubicazione del Cimitero:</label>
                            <textarea className="form-control" id="cimitero" name="cimitero" value={formData.cimitero || ""} onChange={handleChange} disabled={!editMode} />
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="form-group col-sm-12 col-md-8 col-lg-6 mb_30">
                            <label htmlFor="testo">Testo libero <i className="text text-danger">(max {maxChars} caratteri)</i>:</label>
                            <textarea className="form-control" id="testo" name="testo" value={formData.testo || ""} onChange={handleChange} rows="6" maxLength={maxChars} disabled={!editMode} />
                            <div>Caratteri inseriti: {(formData.testo || "").length} / {maxChars}</div>
                            <div>Caratteri rimanenti: {maxChars - (formData.testo || "").length}</div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-12 mb_20">
                            {editMode ? (
                              <div>
                                {/* Modulo di caricamento dell'immagine */}
                                <div className='row mb_20'>
                                  <div className='col-lg-4 col-md-8 col-sm-12 col-xs-10 alert alert-warning'>
                                    <h3>ATTENZIONE:</h3>
                                    Non sono consentiti file non rispondenti ai seguenti requisiti:
                                    <ul>
                                      <li> &nbsp; a) Dimensioni: <b>non</b> superiori a <b>1 MegaBytes</b></li>
                                      <li> &nbsp; b) Formato: <b>.JPG/.JPEG</b> o <b>.PNG</b></li>
                                      <li> &nbsp; c) Dimensioni massime: <b>1920 x 1280 px</b></li>
                                    </ul>
                                  </div>
                                  {formData.img ? (
                                    <div className="col-lg-2 col-md-2 col-sm-4 col-xs-12 mb-3">
                                      <img 
                                      src={`/necrologi/${formData.id_utente}/${formData.img}`} 
                                      alt={`${formData.nome} ${formData.cognome}`} 
                                      onError={(e) => { e.target.src = '/necrologi/vuoto.jpg'; }}
                                      className="img-fluid"
                                    />
                                    </div>
                                  ) : (<div className="col-lg-2 col-md-2 col-sm-4 col-xs-12 mb_20"></div>)}
                                  <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12 mb_20">
                                    <div className="input-group mb-3">
                                      <label className="form-label" htmlFor="file">Scegli il file dal tuo device
                                        <input type="file" className="form-control" name="file" id="file" onChange={handleFileChange} disabled={!editMode} />                                        
                                      </label>
                                    </div>
                                  </div> 
                                </div>
                              </div>
                              ) : (                              
                                <div className="row">
                                  {/* Immagine esistente */}                                
                                  <div className="col-md-3 col-sm-2"></div>
                                  <div className="col-md-6 col-sm-8 col-xs-12 mb_20">
                                    <img 
                                      src={`/necrologi/${formData.id_utente}/${formData.img}`} 
                                      alt={`${formData.nome} ${formData.cognome}`} 
                                      onError={(e) => { e.target.src = '/necrologi/vuoto.jpg'; }}
                                      className="img-fluid"
                                    />
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                    <div className="form-group col-md-8 cols-sm-12 mb_20" style={{textAlign: 'right'}}>
                      {showSuccessMessage && ( // Mostra il messaggio solo se showSuccessMessage è true
                        <div className="alert alert-success mt_20" role="alert">Dati aggiornati con successo!</div>
                      )}
                      {editMode && ( // Mostra il pulsante "Salva" solo se sei in modalità modifica
                        <button type="submit" className="btn btn-primary mt_20">Salva</button>
                      )}
                    </div>
                  </div>
                </form>
                {allegati.length > 0 && (
                  <div className="col-lg-12">
                    <div className="row justify-content-center">
                      <h4 className="text text-center mt_30 mb_30">Partecipazioni & Ringraziamenti</h4>
                      {allegati.map(allegato => (
                        <div className="col-12 mb_30" key={allegato._id}> {/* Aggiungi la key qui */}
                          <div className="row">
                            <div className="col-md-4 col-sm-3"></div>
                            <div className="col-md-4 col-sm-6 col-xs-12 mb_30">
                              <img
                                src={`/necrologi/${allegato.id_utente}/${allegato.img}`}
                                alt="Allegato all'annuncio principale"
                                onError={(e) => { e.target.src = '/necrologi/vuoto.jpg';}}
                                className="img-fluid bordoChiaro"
                              />
                              <button className="btn btn-sm btn-danger" style={{ float: "right"}} onClick={() => handleDeleteAllegato(allegato._id)} title="Elimina questo allegato">
                                <i className='ti-trash'></i> Elimina questo allegato
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Modale di conferma (Bootstrap 5) */}
                <div className={`modal fade ${showConfirmationModalAllegato ? 'show' : ''}`} style={{ display: showConfirmationModalAllegato ? 'block' : 'none', backgroundColor: 'rgba(255, 255, 255, 1)' }} tabIndex="-1">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Conferma eliminazione</h5>
                        <button type="button" className="btn-close" onClick={() => showConfirmationModalAllegato(false)} aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                        <p>Sei sicuro di voler eliminare questo allegato?</p>
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => setShowConfirmationModalAllegato(false)}>Annulla</button>
                        <button type="button" className="btn btn-danger" onClick={confirmDeleteAllegato}>Elimina</button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Fine Modale di conferma */}

              </div>
            </div>
          </div>
        </div>
        <Footer />
                      {/* Modale di conferma (Bootstrap 5) */}
                      <div className={`modal fade ${showConfirmationModal ? 'show' : ''}`} style={{ display: showConfirmationModal ? 'block' : 'none', backgroundColor: 'rgba(255, 255, 255, 1)' }} tabIndex="-1">
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">Conferma eliminazione</h5>
                              <button type="button" className="btn-close" onClick={() => setShowConfirmationModal(false)} aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                              <p>Sei sicuro di voler eliminare questo annuncio?</p>
                            </div>
                            <div className="modal-footer">
                              <button type="button" className="btn btn-secondary" onClick={() => setShowConfirmationModal(false)}>Annulla</button>
                              <button type="button" className="btn btn-danger" onClick={confirmDeleteAnnuncio}>Elimina questo Annuncio</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Fine Modale di conferma */}
      </section>
    </>
  );
}

export default Annuncio;